import React from 'react';

interface BannerProps {
  text?: React.ReactNode;
}

export default function Banner({ text = 'Quienes Somos' }: BannerProps) {
  return (
    <div className="relative top-0 left-0 h-80 w-full p-0 m-0 z-0 bg-gray-100">
      <div className="relative z-0 w-full h-full">
        <article className="px-8 md:pl-16 w-full md:w-1/2 bg-blue-700 md:bg-gray-100 h-full flex flex-col flex-wrap justify-center">
          <h2 className="text-3xl text-center md:text-left md:text-4xl font-bold uppercase text-white md:text-gray-900 break-words">
            {text}
          </h2>
        </article>
      </div>
      <aside
        className="hidden md:block absolute top-0 left-0 z-0 bg-blue-700 bg-center bg-cover bg-scroll h-full w-full"
        style={{
          clipPath: 'polygon(60% 0, 100% 0%, 100% 100%, 40% 100%)',
        }}
      />
    </div>
  );
}
